import React, {Component} from 'react';
import {Progress} from 'antd';

class ProgressForDashboard extends Component {

    render() {
        const { percent, level, type } = this.props;

        return (
            <div className="progress-for-dashboard">
                { level !== undefined &&
                percent !== undefined && (
                    <div className={level.toLowerCase()}>
                        <Progress type="dashboard" percent={percent >= 100 ? 100 : percent}
                                  strokeWidth={5} width={80} status="active"
                                  format={() => <div><div style={{fontSize:'24px'}}>{percent}%</div><div style={{fontSize:'12px'}}>{type}</div></div>}/>
                    </div>
                )}
            </div>
        );
    }
}

export default ProgressForDashboard;


// WEBPACK FOOTER //
// ./src/modules/dashboard/ProgressForDashboard.js